import React from 'react';
import { Link } from 'react-router-dom';
import { useDeviceType } from '@cian/ui-kit';

import { IMainNews } from '../../types/mainNews';
import { NewsItem } from './components/NewsItem';
import * as s from './MainNews.css';

/** Блок новостей на Главной */
export const MainNews = ({ items }: IMainNews) => {
  const deviceType = useDeviceType();
  const isPhone = () => deviceType === 'phone';

  return (
    <div className={`${s['wrapper']}`}>
      <Link to={`/novosti/`} className={`${s['header-link']}`}>
        Новости
      </Link>

      <div className={`${s['separator']}`} />

      {items.map(item => (
        <NewsItem key={`news-${item.id}`} {...item} />
      ))}

      {!isPhone() && (
        <>
          <Link to={`/novosti/`} className={`${s['more-link']}`}>
            Все новости
          </Link>

          <div className={`${s['gradient']}`} />
        </>
      )}
    </div>
  );
};
